var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formModule.isLoading)?_c('DefaFullPageLoader'):_c('TheForm')}
var staticRenderFns = []

export { render, staticRenderFns }